<template>
  <div>
    <label :for="field.name" class="block text-sm font-medium text-gray-700">
      {{ field.label }}<span v-if="field.required">*</span>
    </label>
    <input
      type="checkbox"
      :id="field.name"
      :name="field.name"
      class="focus:ring-blue-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
      v-model="currentValue"
    />
    <p v-if="field.explainer" class="text-sm text-gray-500">
      {{ field.explainer }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'BooleanField',
  props: {
    field: Object,
    value: Boolean,
  },
  data() {
    return {
      currentValue: this.value,
    };
  },
  watch: {
    currentValue: function (newValue) {
      this.$emit('input', {
        target: { name: this.field.name, value: newValue },
      });
    },
  },
};
</script>
